import React from "react";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import api, { apiErr } from "@/lib/api";
import { toast } from "@/components/ui/sonner";
import { BellRing, Mail, CheckCircle2, Clock } from "lucide-react";

const fmtDate = (s) => (s ? new Date(s).toLocaleString("el-GR", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" }) : "—");
const SRC = { bidding: "Αίτημα προσφοράς", reminder: "Υπενθύμιση", manual: "Αίτημα" };

export const VendorRfqHistory = ({ vendor }) => {
  const qc = useQueryClient();
  const { data } = useQuery({ queryKey: ["vendor-rfqs", vendor.id], queryFn: async () => (await api.get(`/procurement/vendors/${vendor.id}/rfqs`)).data });
  const rows = data?.rows || [];
  const remind = useMutation({ mutationFn: async () => (await api.post(`/procurement/vendors/${vendor.id}/remind-missing-prices`)).data,
    onSuccess: (d) => { qc.invalidateQueries({ queryKey: ["vendor-rfqs", vendor.id] }); qc.invalidateQueries({ queryKey: ["vendors"] }); toast.success(d.emailed ? `Στάλθηκε υπενθύμιση για ${d.items} είδη χωρίς τιμή` : `Καταγράφηκε υπενθύμιση για ${d.items} είδη (χωρίς email${d.has_email ? "" : " — λείπει διεύθυνση"})`); },
    onError: (e) => toast.error(apiErr(e)) });
  const missing = (vendor.item_count || 0) - (vendor.priced_item_count || 0);
  return (
    <div className="border-t border-[#E3DED4] pt-4 space-y-2" data-testid="vendor-rfq-history">
      <div className="flex flex-wrap items-center gap-2">
        <div className="text-sm font-medium text-[#45423C]">Ιστορικό αιτημάτων προσφοράς</div>
        <button data-testid="vendor-remind-missing" disabled={missing <= 0 || remind.isPending} onClick={() => remind.mutate()}
          className="ml-auto inline-flex items-center gap-1.5 rounded-lg border border-[#E3DED4] bg-white px-2.5 py-1.5 text-xs font-semibold text-[#C86235] hover:border-[#C86235] disabled:opacity-40"
          title={missing > 0 ? `${missing} είδη χωρίς τιμή` : "Όλα τα είδη έχουν τιμή"}>
          <BellRing className="h-3.5 w-3.5" /> Υπενθύμιση για {missing > 0 ? missing : 0} είδη χωρίς τιμή
        </button>
      </div>
      {rows.length === 0 && <p className="text-xs text-[#8A8577]">Δεν έχει σταλεί αίτημα προσφοράς ακόμη.</p>}
      <div className="max-h-40 overflow-y-auto rounded-xl border border-[#E3DED4] divide-y divide-[#F1EDE6]">
        {rows.map((r) => (
          <div key={r.id} data-testid={`vendor-rfq-${r.id}`} className="flex items-center gap-3 px-3 py-1.5 text-xs">
            <Clock className="h-3.5 w-3.5 text-[#9A948A]" />
            <span className="text-[#45423C] whitespace-nowrap">{fmtDate(r.created_at)}</span>
            <span className="text-[#6F6A60]">{SRC[r.source] || "Αίτημα"} · {r.items_count} είδη</span>
            <span className={`inline-flex items-center gap-1 ${r.emailed ? "text-[#4A7A3E]" : "text-[#9A948A]"}`}><Mail className="h-3 w-3" />{r.emailed ? "email" : "χωρίς email"}</span>
            <span className={`ml-auto inline-flex items-center gap-1 font-semibold ${r.replied >= r.items_count && r.items_count ? "text-[#4A7A3E]" : r.replied ? "text-[#E3B23C]" : "text-[#B4412A]"}`}>
              <CheckCircle2 className="h-3 w-3" /> απάντησε {r.replied}/{r.items_count}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};
